const buttonFileDownBtn = {
  text: 'Descargar informe ZIP (máx.10)'
};

export default buttonFileDownBtn;
